import { MESSAGE_TYPE } from 'shared/constants/messages';

export const getLatestIncomingMessage = messages => {
  return [...(messages || [])].reverse().find(message => {
    return (
      message.message_type === MESSAGE_TYPE.INCOMING &&
      !message.private &&
      message.content?.trim()
    );
  });
};
